import {
  Alert,
  IconButton,
  Modal,
  Snackbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ContratoItemOrigem from "../../../components/classes/ContratoItemOrigem";
import ContratoItemDataSet from "../../../components/data/ContratoItemDataSet";

import DeleteIcon from "@mui/icons-material/Delete";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AddIcon from "@mui/icons-material/Add";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { useTranslation } from "react-i18next";

interface ModalOrigensPropsTypes {
  openOrigens: boolean;
  setOpenOrigens: any;
  itemContratoId: number;
  openModal: any;
}

export default function ModalOrigens(props: ModalOrigensPropsTypes) {
  const { t } = useTranslation();

  /* Datasets */
  const contratoItemDataSet: ContratoItemDataSet = new ContratoItemDataSet();

  /* States */
  const [contratosItemOrigem, setContratosItemOrigem] = useState<
    ContratoItemOrigem[]
  >([]);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [snackBarMessage, setSnackBarMessage] = useState<string>("");

  /* Columns */
  const columns: GridColumns = [
    {
      field: "id",
      headerName: "id",
      width: 60,
      align: "center",
      headerAlign: "center",
      renderHeader: (item) => {
        return <div>#</div>;
      },
    },
    {
      field: "contratoSap",
      headerName: t("global.table.sapContract"),
      width: 250,
      align: "center",
      headerAlign: "center",
      editable: true,
    },
    {
      field: "origem",
      headerName: t("global.table.origin"),
      width: 250,
      align: "center",
      headerAlign: "center",
      editable: true,
    },
    {
      field: "opcoes",
      headerName: t("global.table.options"),
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <>
            <div>
              {
                <Tooltip title={t("global.tooltip.deleteOrigin")}>
                  <span>
                    <IconButton onClick={() => removeOrigem(+item.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              }
            </div>
            <div>
              {
                <Tooltip title={t("global.tooltip.changesHistory")}>
                  <span>
                    <IconButton
                      onClick={() => {
                        props.openModal(item);
                      }}
                    >
                      <ManageSearchIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              }
            </div>
          </>
        );
      },
    },
  ];

  /* Effects */
  useEffect(() => {
    if (props.openOrigens) {
      setIsLoading(true);
      contratoItemDataSet
        .ListarOrigens(props.itemContratoId)
        .then((origens) => {
          setContratosItemOrigem(origens);
        })
        .finally(() => setIsLoading(false));
    }
  }, [props.openOrigens]);

  const cellEditCommit = (event: any) => {
    var editedItem = contratosItemOrigem.find((x) => x.id == event.id);

    if (editedItem) {
      switch (event.field) {
        case "contratoSap":
          if (editedItem.contratoSap == event.value) return;
          editedItem.contratoSap = event.value;
          break;
        case "origem":
          if (editedItem.origem == event.value) return;
          editedItem.origem = event.value;
          break;
      }

      setIsLoading(true);
      contratoItemDataSet
        .AtualizarOrigem(editedItem)
        .then(() => {
          showMessage(t("global.message.rowUpdatedSuccessfully"));
        })
        .finally(() => setIsLoading(false));
    }
  };

  const addNewOrigem = () => {
    var origem = new ContratoItemOrigem();
    origem.idItemContrato = props.itemContratoId;
    origem.contratoSap = "";
    origem.origem = "";

    setIsLoading(true);
    contratoItemDataSet.AdicionarOrigem(origem).then((x) => {
      contratoItemDataSet
        .ListarOrigens(props.itemContratoId)
        .then((origens) => {
          setContratosItemOrigem(origens);
          showMessage(t("global.message.rowUpdatedFillingTheFields"));
        })
        .finally(() => setIsLoading(false));
    });
  };

  const removeOrigem = (id: number) => {
    setIsLoading(true);
    contratoItemDataSet.ApagarOrigem(id).then(() => {
      contratoItemDataSet
        .ListarOrigens(props.itemContratoId)
        .then((origens) => {
          setContratosItemOrigem(origens);
          showMessage(t("global.message.rowDeletedSuccessfully"));
        })
        .finally(() => setIsLoading(false));
    });
  };

  const showMessage = (message: string) => {
    setSnackBarMessage(message);
    setOpenSnackBar(true);
    setTimeout(() => {
      setOpenSnackBar(false);
    }, 3000);
  };

  return (
    <Modal
      open={props.openOrigens}
      onClose={() => props.setOpenOrigens(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="containerBaseModal" style={{ width: "80vw" }}>
        <div className="containerTitleModal">
          <div className="containerTitle">
            <Typography
              variant="h5"
              fontFamily={"Co Headline Regular"}
              gutterBottom
              align="left"
              marginLeft="15px"
            >
              {t("global.contracts.text.contractModalTitle")}
            </Typography>
          </div>
        </div>
        <div className="containerToolbarModal">
          <Tooltip title={t("global.tooltip.addNewOrigin")}>
            <span>
              <IconButton onClick={addNewOrigem}>
                <AddIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t("global.tooltip.closeModal")}>
            <IconButton onClick={() => props.setOpenOrigens(false)}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal" style={{ display: "flex" }}>
          <div className="divFlow">
            <div style={{ height: "50vh", width: "100%" }}>
              <DataGrid
                rows={contratosItemOrigem}
                columns={columns}
                rowsPerPageOptions={[50, 100, 250, 500]}
                onCellEditCommit={cellEditCommit}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
        <Snackbar open={openSnackBar} onClose={() => {}}>
          <Alert onClose={() => {}} severity="success" sx={{ width: "100%" }}>
            {snackBarMessage}
          </Alert>
        </Snackbar>
      </div>
    </Modal>
  );
}
